import api from "../ApiConfig";
import { Apis } from '../../config';
import { NotificationManager } from 'react-notifications';
import unauthService from "../unauth";



const CreateCategory = async (data) => {
    try {
        const result = await api.post(Apis.GetAllCategoryPath, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success(result.data.message, 'Success')
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const GetAllCategoryList = async (data) => {
    try {
        const response = await api.get(Apis.GetAllCategoryPath, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        
        let parsedData = JSON.parse(response.data)
        if (response.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        let result = JSON.parse(parsedData.body)
        console.log("categorylist" , result)
        return result.additionalData;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};

const UpdateCategoryList = async (data,id) => {
    try {
        const result = await api.put(Apis.GetAllCategoryPath+'?id='+id, data, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success(result.data.message, 'Success')
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};
const DeleteCategoryList = async (id) => {
    try {
        const result = await api.delete(Apis.GetAllCategoryPath+'?id='+id, {
            // withCredentials: true,
            headers: { 'Content-Type': 'application/json' }
        });
        if (result.data.error) {
            NotificationManager.error(result.data.error);
            return null;
        }
        NotificationManager.success(result.data.message, 'Success')
        return result.data;
    } catch (error) {
        if(error.status==401){
            unauthService()
           }
        console.error('Error in getUserLogin:', error);
        NotificationManager.error('An error occurred while logging in.');
        return null;
    }
};



export default {
    GetAllCategoryList,
    UpdateCategoryList,
    DeleteCategoryList,
    CreateCategory
};